export interface ProductReq {
  shipmentLocationId: number;
  shippingConditionId: number;
  productLineId: number;
  salesDocumentTypeId: number;
  purchaseOrder?: string;
  productCode: string;
}
